export default[
	{
		path: '/deposits/list',
		name: 'DepositList',
		component: () => import('@/Modules/DepositList/Views/DepositList.vue'),
		meta : {
			title : 'Deposit List'
		}
	},
	{
		path: '/deposits/fixed/:id',
		name: 'FixedDeposit',
		component: () => import('@/Modules/DepositList/Views/FixedDeposit.vue'),
		meta : {
			title : 'Fixed Deposit'
		}
	},
	{
		path: '/deposits/fixed/:id/ledger',
		name: 'FixedDepositLedger',
		component: () => import('@/Modules/DepositList/Views/FixedDepositLedger.vue'),
		meta : {
			title : 'Fixed Deposit Ledger'
		}
	},
	
	{
		path: '/deposits/savings/:id',
		name: 'SavingsDeposit',
		component: () => import('@/Modules/DepositList/Views/SavingsDeposit.vue'),
		meta : {
			title : 'Savings Deposit'
		}
	},
	{
		path: '/deposits/savings/:id/ledger',
		name: 'SavingsDepositLedger',
		component: () => import('@/Modules/DepositList/Views/SavingsDepositLedger.vue'),
		meta : {
			title : 'Savings Deposit Ledger'
		}
	},
	
	
	{
		path: '/deposits/cumulative/:id',
		name: 'CumulativeDeposit',
		component: () => import('@/Modules/DepositList/Views/CumulativeDeposit.vue'),
		meta : {
			title : 'Cumulative Deposit'
		}
	},
	{
		path: '/deposits/cumulative/:id/ledger',
		name: 'CumulativeDepositLedger',
		component: () => import('@/Modules/DepositList/Views/CumulativeDepositLedger.vue'),
		meta : {
			title : 'Cumulative Deposit Ledger'
		}
	},
	
	
	{
		path: '/deposits/recurring/:id',
		name: 'RecurringDeposit',
		component: () => import('@/Modules/DepositList/Views/RecurringDeposit.vue'),
		meta : {
			title : 'Recurring Deposit'
		}
	},
	
	{
		path: '/deposits/recurring/:id/ledger',
		name: 'RecurringDepositLedger',
		component: () => import('@/Modules/DepositList/Views/RecurringDepositLedger.vue'),
		meta : {
			title : 'Recurring Deposit Ledger'
		}
	},
	
	
	{
		path: '/deposits/recurring/:id/installment-schedule',
		name: 'RecurringDepositInstallmentSchedule',
		component: () => import('@/Modules/DepositList/Views/RecurringInstallmentSchedule.vue'),
		meta : {
			title : 'Recurring Deposit Installment Schedule'
		}
	},	
	
	
]


